module.exports = __webpack_public_path__ + "static/media/audio.22320c27.svg";